<mat-toolbar class="secondary-toolbar mat-elevation-z1">
</mat-toolbar>

<section class="main-content">
  <div style="height:100px; padding-bottom:20px;">
    <mat-grid-list cols="5" gutterSize="20px" rowHeight="fit" style="height:100%">
      <mat-grid-tile>
        <app-info-tile label="Total Companies" labelToolTip="The total number of companies within your account, including your own." [primaryValue]="totalAccounts" [secondaryValue]="totalAccountsChg" secondaryType="CHANGE"></app-info-tile>
      </mat-grid-tile>
      <mat-grid-tile>
        <app-info-tile label="Assessments Created" [primaryValue]="created" [secondaryValue]="createdChg" secondaryType="CHANGE"></app-info-tile>
      </mat-grid-tile>
      <mat-grid-tile>
        <app-info-tile label="Assessments Completed" [primaryValue]="completed" [secondaryValue]="completedPerc" secondaryType="PERCENTAGE"></app-info-tile>
      </mat-grid-tile>
      <mat-grid-tile>
        <app-info-tile label="Assessments In Progress" [primaryValue]="inProgress" [secondaryValue]="inProgressPerc" secondaryType="PERCENTAGE"></app-info-tile>
      </mat-grid-tile>
      <mat-grid-tile>
        <app-info-tile label="Assessments Not Started" [primaryValue]="notStarted" [secondaryValue]="notStartedPerc" secondaryType="PERCENTAGE"></app-info-tile>
      </mat-grid-tile>
    </mat-grid-list>
  </div>
  <mat-grid-list cols="5" gutterSize="20px" rowHeight="215px">        
    <mat-grid-tile colspan="3">
      <app-score-histogram-component [parentAccount]="_sessionService.getCurrentAccount()"></app-score-histogram-component>
    </mat-grid-tile>
    <mat-grid-tile rowspan="2" colspan="2">
      <app-account-risk-by-quarter [parentAccount]="_sessionService.getCurrentAccount()"></app-account-risk-by-quarter>
    </mat-grid-tile>  
    <mat-grid-tile colspan="3">
      <app-assessment-status-by-quarter [parentAccount]="_sessionService.getCurrentAccount()"></app-assessment-status-by-quarter>
    </mat-grid-tile>
    <mat-grid-tile *ngIf="false" colspan="5" rowspan="2">
      <div class="dashboard-tile">
        <div class="tile-header">
          <div class="tile-header-title">Assessments</div>
        </div>
        <div class="tile-content">
          <div class="table-wrapper" style="height:inherit;">
            <table mat-table [dataSource]="assessments" style="width:100%;">
              <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef>Company Name</th>
                <td mat-cell *matCellDef="let element"> {{element.name}} </td>
              </ng-container>

              <ng-container matColumnDef="contact">
                <th mat-header-cell *matHeaderCellDef>Contact</th>
                <td mat-cell *matCellDef="let element"> {{element.contact}} </td>
              </ng-container>

              <ng-container matColumnDef="location">
                <th mat-header-cell *matHeaderCellDef>Location</th>
                <td mat-cell *matCellDef="let element"> {{element.location}} </td>
              </ng-container>

              <ng-container matColumnDef="email">
                <th mat-header-cell *matHeaderCellDef>Email</th>
                <td mat-cell *matCellDef="let element"> {{element.email}} </td>
              </ng-container>

              <ng-container matColumnDef="progress">
                <th mat-header-cell *matHeaderCellDef>Current Assessment Progress</th>
                <td mat-cell *matCellDef="let element">
                  <div class="custom-progress-bar" [ngClass]="{'progress-not-started':element.progress==0}" style="width:200px">
                    <div class="bg-primary" [ngStyle]="{'width': getProgressPercent(element.progress)}">{{element.progress}} %</div>
                  </div>
                </td>
              </ng-container>

              <ng-container matColumnDef="score-history">
                <th mat-header-cell *matHeaderCellDef>Trend</th>
                <td mat-cell *matCellDef="let element">
                  <app-score-history-graph></app-score-history-graph>
                </td>
              </ng-container>
            
              <tr mat-header-row *matHeaderRowDef="columnsToDisplay; sticky: true"></tr>
              <tr mat-row *matRowDef="let row; columns: columnsToDisplay;" class="alternating-bg bg-accent-hover"></tr>
            </table>
          </div>
        </div>
      </div>
    </mat-grid-tile>
  </mat-grid-list>
</section>
